<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 4.8125 9 A 1.0001 1.0001 0 0 0 4 10 C 4 11.654545 2.6545455 13 1 13 A 1.0001 1.0001 0 0 0 0 14 L 0 36 A 1.0001 1.0001 0 0 0 1 37 C 2.6545455 37 4 38.345455 4 40 A 1.0001 1.0001 0 0 0 5 41 L 45 41 A 1.0001 1.0001 0 0 0 46 40 C 46 38.345455 47.345455 37 49 37 A 1.0001 1.0001 0 0 0 50 36 L 50 14 A 1.0001 1.0001 0 0 0 49 13 C 47.345455 13 46 11.654545 46 10 A 1.0001 1.0001 0 0 0 45 9 L 5 9 A 1.0001 1.0001 0 0 0 4.90625 9 A 1.0001 1.0001 0 0 0 4.8125 9 z M 5.78125 11 L 44.21875 11 C 44.629083 12.919703 46.080297 14.370917 48 14.78125 L 48 35.21875 C 46.080297 35.629083 44.629083 37.080297 44.21875 39 L 5.78125 39 C 5.3709173 37.080297 3.9197032 35.629083 2 35.21875 L 2 14.78125 C 3.9197032 14.370917 5.3709173 12.919703 5.78125 11 z M 10 20 L 10 22 L 40 22 L 40 20 L 10 20 z M 10 28 L 10 30 L 40 30 L 40 28 L 10 28 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "category",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
